<div class="dash">
    <div class="row">
        <div class="col-12 ml-auto mr-auto">
            <div class="dash-card no-padding">
                <div class="dash-card-header d-block"
                    style="flex-direction: column;">
                    <div class="row no-gutters">
                        <div class="col-12">
                            <h2>Vínculos de minutas</h2>
                        </div>
                    </div>

                    <div class="row no-gutters">
                        <div
                            class="col-12 d-flex justify-content-end mt-3 px-0">
                            <ng-container *ngIf="loadingDrafts">
                                <ngx-skeleton-loader [theme]="{
                                    width: '120px',
                                    height: '40px',
                                    marginRight: '8px'
                                  }">
                                </ngx-skeleton-loader>
                                <ngx-skeleton-loader [theme]="{
                                    width: '120px',
                                    height: '40px',
                                    marginRight: '8px'
                                  }">
                                </ngx-skeleton-loader>
                                <ngx-skeleton-loader [theme]="{
                                    width: '200px',
                                    height: '40px'
                                  }">
                                </ngx-skeleton-loader>
                            </ng-container>

                            <ng-container *ngIf="!loadingDrafts">
                                <app-button
                                    *ngIf="hasFilters && permissionObj.canFilter"
                                    [danger]="true" [outline]="true"
                                    class="mr-2" (onClick)="resetForm()">
                                    <i
                                        class="fas fa-times filter-clear-icon"></i>
                                    Limpar filtros
                                </app-button>

                                <app-button (onClick)="toggleFilterModal()"
                                    [inverted]="true" class="add-button mr-2"
                                    *ngIf="permissionObj.canFilter">
                                    <svg-icon
                                        src="assets/images/icon_filter.svg"
                                        class="mr-2"></svg-icon>
                                    {{ hasFilters ? 'Editar filtros' : 'Filtrar
                                    listagem' }}
                                </app-button>

                                <app-button (onClick)="redirectToForm()"
                                    class="add-button"
                                    *ngIf="permissionObj.canAdd">
                                    <svg-icon src="assets/images/icon-add.svg"
                                        class="mr-2"></svg-icon>
                                    Criar novo vínculo de minuta
                                </app-button>
                            </ng-container>
                        </div>
                    </div>

                    <div class="col-12 mt-3 px-0"
                        *ngIf="!loadingDrafts && hasFilters && appliedFilters.length > 0">
                        <div
                            class="d-flex flex-wrap align-items-center justify-content-end">
                            <app-filter-tag
                                *ngFor="let filter of appliedFilters"
                                [label]="filter.label" [value]="filter.value">
                            </app-filter-tag>
                        </div>
                    </div>
                </div>

                <ng-container
                    *ngIf="!loadingDrafts && drafts.length === 0 && !hasFilters">
                    <app-empty-content [isVisible]="true" [large]="true"
                        title="Não há nenhum vínculo de minuta para exibir"
                        description="Não há vínculos de minutas para serem exibidos no momento, para criar um novo vínculo clique no botão abaixo."
                        icon="/assets/images/figure_3d_search.png"
                        (onClick)="redirectToForm()" [haveButtonIcon]="true"
                        buttonLabel="Criar novo vínculo de minuta">
                    </app-empty-content>
                </ng-container>

                <ng-container
                    *ngIf="!loadingDrafts && drafts.length === 0 && hasFilters">
                    <app-empty-content [isVisible]="true" [large]="true"
                        title="Nenhum resultado encontrado"
                        description="Não foram encontrados vínculos de minutas com os filtros aplicados. Tente ajustar os filtros para ver mais resultados."
                        icon="/assets/images/figure_3d_search.png">
                    </app-empty-content>
                </ng-container>

                <div class="dash-card-body  padding-container">
                    <div clsas="styled-scroll">
                        <ng-container *ngIf="loadingDrafts">
                            <table #table>
                                <thead>
                                    <tr>
                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th>
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>

                                        <th class="text-right">
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '125px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                            height: '15px',
                                            width: '100px',
                                        marginBottom:'0'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td class="item-number">
                                            <ngx-skeleton-loader [theme]="{
                                        height: '15px',
                                        width: '30px',
                                        marginBottom:'0'
                                      }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>

                        <table class="bordered"
                            *ngIf="!loadingDrafts && drafts.length > 0">
                            <thead>
                                <tr>
                                    <th>Template utilizado</th>
                                    <th>Criado em</th>
                                    <th>Tipo de documento</th>
                                    <th>Fundo vinculado</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let draft of drafts">
                                    <td>
                                        {{renderLabel(draft.draft_document)}}
                                    </td>
                                    <td>
                                        {{draft.initial_date | date:
                                        'dd/MM/yyyy' ?? '-'}}
                                    </td>
                                    <td>
                                        {{renderType(draft.type)}}
                                    </td>
                                    <td>
                                        {{renderFundLabel(draft.fund)}}
                                    </td>

                                    <td>
                                        <div class="status-tag"
                                            *ngIf="!draft.is_draft"
                                            [class.-inactive]="!draft.active">
                                            {{draft.active ? 'Ativado' :
                                            renderDisabledStatus(draft)}}
                                        </div>

                                        <div class="status-tag draft"
                                            *ngIf="draft.is_draft">
                                            Rascunho
                                        </div>
                                    </td>
                                    <td>
                                        <div class="dash-card-item-buttons">
                                            <app-tooltip text="Editar"
                                                position="top"
                                                *ngIf="permissionObj.canEdit">
                                                <button class="dash-item-button"
                                                    (click)="redirectToForm(draft.draft_document)">
                                                    <svg-icon
                                                        src="assets/images/icon-edit.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-spacer [right]="16"
                                                *ngIf="!draft.is_draft"></app-spacer>

                                            <ng-container
                                                *ngIf="!draft.is_draft">
                                                <app-tooltip text="Inativar"
                                                    position="top"
                                                    *ngIf="permissionObj.canChange && !draft.error && draft.active">
                                                    <button
                                                        class="dash-item-button"
                                                        (click)="toggleDraftStatus(draft.id)">
                                                        <i
                                                            class="fas fa-ban"></i>
                                                    </button>
                                                </app-tooltip>
                                                <app-tooltip text="Ativar"
                                                    position="top"
                                                    *ngIf="permissionObj.canChange && !draft.error && !draft.active">
                                                    <button
                                                        class="dash-item-button"
                                                        (click)="toggleDraftStatus(draft.id)">
                                                        <i
                                                            class="fas fa-check"></i>
                                                    </button>
                                                </app-tooltip>
                                                <ng-container
                                                    *ngIf="draft.error">
                                                    <app-spacer
                                                        [right]="16"></app-spacer>
                                                    <app-tooltip
                                                        text="Visualizar"
                                                        position="top">
                                                        <button
                                                            class="dash-item-button"
                                                            (click)="openWarningModal(draft.id)">
                                                            <i
                                                                class="fas fa-eye"></i>
                                                        </button>
                                                    </app-tooltip>
                                                </ng-container>
                                            </ng-container>
                                        </div>
                                    </td>
                                </tr>


                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12 ml-auto mr-auto"
            *ngIf="!loadingDrafts && drafts.length > 0">
            <div class="dash-card-pagination">
                <app-pagination [data]="drafts" [count]="count"
                    [show]="!loadingDrafts" [offset]="offset"
                    (onPageChange)="changePageData($event)"
                    [dashPagination]="true" [resultsPerPage]="results_per_page">
                </app-pagination>
            </div>
        </div>
    </div>
</div>

<app-side-filter-modal [active]="showFilterModal" [formGroup]="form"
    [loading]="loadingDrafts" title="Filtrar listagem"
    (onClose)="toggleFilterModal()" (onApply)="submitForm()"
    (onReset)="resetForm()" [disableApplyButton]="!canApplyFilters">
    <div class="row">
        <div class="col-12">
            <app-input [group]="form" controlName="draft_document_name"
                label="Template utilizado" placeholder="Digite">
            </app-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-8">
            <app-select [items]="typeItems" [group]="form" controlName="type_id"
                label="Tipo de documento" placeholder="Selecione">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12 col-lg-4">
            <app-select [items]="statusItems" [group]="form"
                controlName="active" label="Status" placeholder="Selecione">
            </app-select>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-lg-6">
            <app-masked-input [group]="form" controlName="start_date"
                mask="00/00/0000" label="Início da vigência"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>

        <div class="col-12 col-lg-6">
            <app-masked-input [group]="form" controlName="end_date"
                mask="00/00/0000" label="Fim da vigência"
                placeholder="dd/mm/aaaa">
            </app-masked-input>
            <app-spacer [bottom]="16"></app-spacer>
        </div>
    </div>
</app-side-filter-modal>

<!-- Carbon Warning Modal para mudança de status -->
<app-carbon-warning-modal [active]="showStatusModal" [title]="getModalTitle()"
    [message]="getModalMessage()" [confirmText]="getConfirmText()"
    [cancelText]="'Não, manter como está'"
    [confirmAction]="confirmStatusChange.bind(this)"
    [cancelAction]="closeStatusModal.bind(this)" (onClose)="closeStatusModal()">
</app-carbon-warning-modal>